// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as React from "react";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as ScoreCard from "../v1/ScoreCard.bs.js";
import * as ScoreCardV2 from "../v2/ScoreCardV2.bs.js";
import * as LockedScoreCard from "../v1/LockedScoreCard.bs.js";
import * as LockedScoreCardV2 from "../v2/LockedScoreCardV2.bs.js";
import * as PartnerScoreHelper from "../../../domain/helper/PartnerScoreHelper.bs.js";
import * as PartnerScoreAssetManager from "../../assets/PartnerScoreAssetManager.bs.js";
import * as PartnerScoreContentManager from "../../content/PartnerScoreContentManager.bs.js";

PartnerScoreAssetManager.importCss(undefined);

function PartnerScoreCmp(Props) {
  var msisdn = Props.msisdn;
  var geo_region = Props.geo_region;
  var scores = Props.scores;
  var language = Props.language;
  var vehicle_category = Props.vehicle_category;
  return React.createElement("div", {
              className: "c-partner-score-dashboard-wrapper"
            }, $$Array.of_list(Belt_List.map(scores, (function (performance_score) {
                        var content = PartnerScoreContentManager.getContentModule(language, performance_score, vehicle_category, geo_region);
                        var score_state = PartnerScoreHelper.stringToScoreStateEnum(performance_score.locked_state);
                        var score_type = PartnerScoreHelper.stringToScoreTypeEnum(performance_score.name);
                        switch (score_state) {
                          case /* UNLOCKED */0 :
                              switch (score_type) {
                                case /* COMPLETION_SCORE */0 :
                                    return React.createElement(ScoreCard.make, {
                                                msisdn: msisdn,
                                                content: content.content_v1,
                                                performance_score: performance_score
                                              });
                                case /* CANCELLATION_SCORE */1 :
                                    return React.createElement(ScoreCardV2.make, {
                                                msisdn: msisdn,
                                                content: content.content_v2,
                                                performance_score: performance_score
                                              });
                                case /* DEFAULT */2 :
                                    return null;
                                
                              }
                          case /* LOCKED */1 :
                              switch (score_type) {
                                case /* COMPLETION_SCORE */0 :
                                    return React.createElement(LockedScoreCard.make, {
                                                msisdn: msisdn,
                                                content: content.content_v1,
                                                performance_score: performance_score
                                              });
                                case /* CANCELLATION_SCORE */1 :
                                    return React.createElement(LockedScoreCardV2.make, {
                                                msisdn: msisdn,
                                                content: content.content_v2,
                                                performance_score: performance_score
                                              });
                                case /* DEFAULT */2 :
                                    return null;
                                
                              }
                          case /* DEFAULT */2 :
                              return null;
                          
                        }
                      }))));
}

var make = PartnerScoreCmp;

export {
  make ,
  
}
/*  Not a pure module */
